import ValueInterface, { SerializedValueType } from "./ValueInterface"

export default class NumberValue implements ValueInterface {
  constructor(private readonly value: number) {}

  public toString(): string {
    return this.value.toString() // @todo add formatting
  }
  public normalize(): number {
    return this.value
  }

  public clone(): NumberValue {
    return new NumberValue(this.value)
  }

  public toJSON(): SerializedValueType {
    return {
      type: "number",
      payload: { value: this.value.toString() },
    }
  }
}
